export class Bounds {
  minX = Infinity;
  minY = Infinity;
  maxY = 0;
  maxX = 0;

  avgX = 0;
  avgY = 0;
  count = 0;

  extend(x: number, y: number) {
    this.minX = Math.min(this.minX, x);
    this.minY = Math.min(this.minY, y);
    this.maxX = Math.max(this.maxX, x);
    this.maxY = Math.max(this.maxY, y);

    this.avgX = (this.avgX * this.count + x) / (this.count + 1);
    this.avgY = (this.avgY * this.count + y) / (this.count + 1);
    this.count++;
    return this;
  }

  clone() {
    const b = new Bounds();
    b.minX = this.minX;
    b.minY = this.minY;
    b.maxX = this.maxX;
    b.maxY = this.maxY;
    b.avgX = this.avgX;
    b.avgY = this.avgY;
    b.count = this.count;
    return b;
  }

  expand(amount: number) {
    this.minX -= amount;
    this.minY -= amount;
    this.maxX += amount;
    this.maxY += amount;
    return this;
  }

  extendBounds(bounds: Bounds) {
    this.minX = Math.min(this.minX, bounds.minX);
    this.minY = Math.min(this.minY, bounds.minY);
    this.maxX = Math.max(this.maxX, bounds.maxX);
    this.maxY = Math.max(this.maxY, bounds.maxY);
    return this;
  }

  scale(scale: number) {
    this.minX *= scale;
    this.minY *= scale;
    this.maxX *= scale;
    this.maxY *= scale;
  }

  get width() {
    return this.maxX - this.minX;
  }

  get height() {
    return this.maxY - this.minY;
  }

  get centerX() {
    return (this.minX + this.maxX) / 2;
  }

  get centerY() {
    return (this.minY + this.maxY) / 2;
  }

  contains(x: number, y: number) {
    return x >= this.minX && x <= this.maxX && y >= this.minY && y <= this.maxY;
  }
}
